import { useRollbar } from '@rollbar/react';

// src/universal/tracker/index.ts
var useTracker = () => {
  const rollbar = useRollbar();
  const captureError = (error, options = {}) => {
    const { tags = [], extras = {}, fingerprint = ["{{ default }}"] } = options;
    rollbar.error(error.errorMessage, error, {
      tags,
      extras,
      fingerprint
    });
  };
  return { captureError };
};

export { useTracker };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-TTQ65QRH.mjs.map